import type { ReactNode } from 'react'

import { SkalxAiIcon } from 'src/components'
import { AssistantTimeline, ChatConversation } from 'src/components/chat'
import type {
  ApprovalResolution,
  ChatComposerExtras,
  ChatMessage,
  Conversation,
  QuestionResolution,
  ResolveAttachmentUrl
} from 'src/components/chat'

import { TurnFeedback } from './TurnFeedback'

const AI_ICON_SIZE = 24

type Props = {
  conversation: Conversation
  input: string
  onChange: (value: string) => void
  onSend: () => void
  onStop: () => void
  streaming: boolean
  disabled?: boolean
  hideComposer?: boolean
  hideTitle?: boolean
  compact?: boolean
  appToken?: string
  modelName?: string
  /** Assistant-turn avatar. Falls back to the Skalx brand mark. */
  aiIcon?: ReactNode
  showCopyTooltip?: boolean
  loadingHistory?: boolean
  onApprovalResolve?: (action: ApprovalResolution) => void
  onQuestionResolve?: (resolution: QuestionResolution) => void
  resolveAttachmentUrl?: ResolveAttachmentUrl
  composerExtras?: ChatComposerExtras
}

export const SquadChatConversation = ({
  appToken,
  aiIcon,
  onApprovalResolve,
  onQuestionResolve,
  ...rest
}: Props) => (
  <ChatConversation
    {...rest}
    aiIcon={aiIcon ?? <SkalxAiIcon size={AI_ICON_SIZE} />}
    renderTimeline={(message: ChatMessage, streaming: boolean) => (
      <AssistantTimeline
        timeline={message.timeline ?? []}
        streaming={streaming}
        live={!!message.live}
        onApprovalResolve={onApprovalResolve}
        onQuestionResolve={onQuestionResolve}
      />
    )}
    renderFeedback={(message: ChatMessage, threadId: string) =>
      appToken && message.runId ? (
        <TurnFeedback
          appToken={appToken}
          threadId={threadId}
          runId={message.runId}
        />
      ) : null
    }
  />
)
